<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list" class="relative">
    <div class="page_header_wrap" :class="{ filters_open: filtersList }">
      <div class="page_header">
          <div>
            <h2 ><a><img src="@/assets/images/pages/arrow.png"></a>Domains</h2>
          </div>
          <div class="page_actions">
            <div class="page_search">
              <input
                v-model="serch_title"
                  class="search_field"
                  type="text"
                  @keyup="onEnter"
                  placeholder="Search By Name"
                />
            </div>
            <button v-if="activeUserInfo.roleId == 1" class="secondary_btn add" @click="openCreatePop">
              Create Domain
            </button>
            <!-- <button  class="secondary_btn filters_btn" :class="{ active: filtersList }" @click="filtersList = !filtersList">
              <span class="material-icons"> filter_list</span>Filters
            </button> -->
          </div>
        </div> 
        <div class="filter_layer" @click="filtersList = !filtersList"></div>
        <div
      ref="filterCard" 
      class="user-list-filters filters_list"
      actionButtons
      @refresh="resetColFilters"
      @remove="resetColFilters"
    >
      <div class="vx-row">
        <div class="vx-col md:w-2/4 sm:w-1/2 w-full marb10">
         <label class="text-sm opacity-75">Search</label>
          <input
           v-model="serch_title"
            class="search_field"
            type="text"
            @keyup.enter="onEnter"
            placeholder="Search By Name"
          />
        </div>
        <!-- <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Created Date</label>
          <date-range-picker :autoApply="autoApply" :ranges="false"   v-model="selected_createdDateRange"></date-range-picker>
        </div> -->
        <div class="vx-col md:w-2/4 sm:w-1/2 w-full d-flex align-end justify-end marb10" >
          <button @click="clearFilters()" class="secondary_btn">
              Clear
            </button>
          <button class="primary_btn marl15" @click="getList() , filtersList = !filtersList" >
            Apply 
          </button>
        </div>
        
      </div>
    </div>
    </div>



    <div class="invite_btn">
      <button v-if="activeUserInfo.roleId == 1" class="secondary_btn add" @click="openCreatePop">
        Create Group
      </button>
    </div>
    

    <!--<tableheader
      @applyFilter="apply_filter"
      @cancle_filter="cancle_filter"
    ></tableheader>-->

    <div class="vx-card">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow d-flex justify-content-between"></div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <!-- <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." /> -->
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

        <!-- ACTION - DROPDOWN -->
        <!-- <vs-dropdown vs-trigger-click class="cursor-pointer">

            <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
              <span class="mr-2 leading-none">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>CSV</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown> -->
      </div>

      <vs-table :data="users" noDataText="">
        <template slot="thead">
          <vs-th>
             <span>
              <a
                @click="sortMe('domainName')"
                v-bind:class="{
                  sort_ascending: sortKeys['domainName'] == 1,
                  sort_descending: sortKeys['domainName'] != 1,
                }"
                > Domain  Name</a
                
              >
            </span>
          
          </vs-th>
          <vs-th>
            <span>
              <a
                @click="sortMe('companyName')"
                v-bind:class="{
                  sort_ascending: sortKeys['companyName'] == 1,
                  sort_descending: sortKeys['companyName'] != 1,
                }"
                >Company Name</a
              >
            </span>
          </vs-th>
          <vs-th> Action </vs-th>
         
        </template>

        <template v-if="rolesList && rolesList.length > 0">
          <vs-tr v-for="(item, index) in rolesList" :key="index">
            <vs-td>
              {{ item.domainName}}
            </vs-td>
            <vs-td>
              {{ item.companyName}}
            </vs-td>
            <vs-td class="w-200">
              <button
                class="secondary_btn edit_btn marl0"
                @click="getDetails(item)" >
                Edit
              </button>
               <button
                class="secondary_btn edit_btn marl0 ml-2"
                @click="openOndelete(item)" >
                Delete
              </button>
              
            </vs-td>
          </vs-tr>
        </template>
        <template v-else>
          <tr v-if="!loading">
            <td colspan="3" class="center-align">No Domains Found!</td>
          </tr>
        </template>
      </vs-table>
     

    </div>
    <div class="pagination_wrap" v-if="totalpages > 0">
      <div class="pagination_content">
        <h6>Show Records</h6>
        <!-- <v-select
          @input="change_perPage()"
          v-model="perPage"
          :options="perPeges"
          label="Per Page"
          solo
        ></v-select> -->

        <multiselect
          :multiple="false" 
            @input="change_perPage()"
          placeholder="Page"
          
          :close-on-select="true"
          :clear-on-select="false"
          :hide-selected="true"
          :preserve-search="true"
          v-model="perPage" :options="perPeges" >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span
                class="multiselect__selectcustom"
                v-if="values.length && !isOpen"
                >{{ values.length }} selected</span
              >
              <span
                class="multiselect__selectcustom"
                v-if="values.length && isOpen"
              ></span>
            </template>
            
          </multiselect>
      </div>
      <vs-pagination
        :total="totalpages"
        :max="7"
        v-model="page"
        @input="getList()"
      />
    </div>
    <vs-popup
      v-if="popupcreateticket"
      class="holamundo"
      :active.sync="popupcreateticket"
      :title="popupTitle"
    >
      <div class="createticket_form">
        <form autocomplete="off">
          <div class="form-group w-full">
       
              <lable class="form_label">Domain Name*</lable>
              <vs-input
                v-validate="'required'"
                name="Domain Name"
                icon-no-border
                icon-pack="feather" 
                v-model="domainCreate.domainName"
                class="w-full" 
                oninput="this.value = this.value.replace(/[^a-z A-Z 0-9 .]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"              
              />             
              <span class="text-danger text-sm">{{errors.first("Domain Name")}}</span>
            </div>
            
          <div class="form-group w-full">
              <lable class="form_label">Company Name*</lable>
              <vs-input
                oninput="this.value = this.value.replace(/[^a-z A-Z 0-9]/g, '').replace(/(\..*)\./g, '$1'); "              
              
                v-validate="'required'"
                name="Company Name"
                icon-no-border
                icon-pack="feather" 
                v-model="domainCreate.companyName"
                class="w-full"               
              />             
              <span class="text-danger text-sm">{{errors.first("Company Name")}}</span>
            </div>
          <div class="form-group w-full">
                <div class="flex items-center">
                    <vs-checkbox :icon="selectAllIcon" v-model="domainCreate.ndaSigned" icon-pack="feather"  class="select-all-chexkbox ml-0">NDA Agreed</vs-checkbox>
                </div>
            </div>
         
        </form>
        <div class="form_actions">
       
          <span></span>
          <vs-button v-if="!updateUser"
            class="close_popup primary_btn"
            @click="onSubmit()"
            :disabled="!validateForm"
            >Create
          </vs-button>
          <vs-button v-if="updateUser"
            class="close_popup primary_btn"
            @click="onSubmit()"
            > Update
          </vs-button>
        </div>
      </div>
    </vs-popup>

   
    <vs-popup
      class="holamundo"
      :active.sync="deletePopup"
      title="Activate User"
    >
      <div class="createticket_form alert_messages">
        <p>
          Are you sure want to Delete the Domain ?
        </p>
        <div class="form_actions">
          <span></span>
          <button class="close_popup primary_btn" @click="deleteMe()">
            Delete
          </button>
        </div>
      </div>
    </vs-popup>

   
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import tableheader from "@/views/pages/UsersListHeaders.vue";
import noData from "@/views/components/noData.vue";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

// Store Module
import moduleUserManagement from "@/store/user-management/moduleUserManagement.js";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import Multiselect from "vue-multiselect-inv";

export default {
  components: {
    AgGridVue,
    vSelect,
    tableheader,
    DateRangePicker,
    VuePhoneNumberInput,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
    Multiselect,
  },
  data() {
    return {
      loading:true,
      filtersList: false,
      popupTitle:"Create Domain",
      popupcreateticket: false,
      popupApprove: false,
      switch1: true,
      switch2: true,
      switch3: true,
      rolesList: [],
      sortKey: {},
      email: "",
      users: "",
      page: 1,
      perPage: 25,
      totalpages: 0,
      selected_statuss: [],
      status_list: [],
      cusId: "",
      updateUser: false,
      activeUserFlag: false,
       selected_createdDateRange:{},
      autoApply: "",
      inActiveUserFlag: false,
      userId: "",

      sortKeys: {
        companyName: 1,
        domainName: 1,
        createdOn: -1,
      
      },

      startDate: new Date(),
      endDate: new Date(),
      serch_title: "",

      userRoles: [],
      createUserRoles: [],
      selected_userRoles: [],
      settings_list: [],
      /*   settings_list: [
         { name: 'SDK Download', _id: 'sdkDownload' },
        { name: 'SDK Docs', _id: 'sdkDocs' },
        { name: 'Support Tickets', _id: 'supportTicket' },
      ],
      settings: {
        sdkDownload : false,
        sdkDocs : false,
        supportTicket : false
      },*/
      selected_settings: [],
      searchQuery: "",

      domainCreate: {

          "domainId": "",
    	"domainName": "",
    	"companyName": "",
    	"ndaSigned": true
      },
      // AgGrid
      gridApi: null,
      gridOptions: {},
      perPeges: [25, 50, 75, 100],
      filterData: {
        statusIds: [],
        roleIds: [],
        createdOnRange: [],
      },

      userFilters: {
        statusIds: [],
        roleIds: [],
        createdOnRange: [],
      },

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
      },
      deletePopup:false,
    };
  },
  watch: {
    roleFilter(obj) {
      this.setColumnFilter("role", obj.value);
    },
    statusFilter(obj) {
      this.setColumnFilter("status", obj.value);
    },
    isVerifiedFilter(obj) {
      const val =
        obj.value === "all" ? "all" : obj.value === "yes" ? "true" : "false";
      this.setColumnFilter("is_verified", val);
    },
    departmentFilter(obj) {
      this.setColumnFilter("department", obj.value);
    },
  },
  computed: {
       selectAllIcon () {
      return this.domainCreate.ndaSigned ? 'icon-check' : 'icon-minus'
    },
    activeUserInfo () {
      console.log(JSON.stringify(this.$store.state.auth.user));
      return this.$store.state.auth.user
    },
    usersData() {
      return this.$store.state.userManagement.users;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.domainCreate.domainName !== ""
       &&  this.domainCreate.companyName !== ""
      );
    },
  },
  methods: {
    openCreatePop() {
      this.popupTitle = "Create Domain";
      this.initUser();
      this.popupcreateticket = true;
      this.updateUserKey();
      
    },
    
    onUpdateStatus() {
      let statusId = 3;
      if (this.activeUserFlag) {
        statusId = 2;
      } else if (this.inActiveUserFlag) {
        statusId = 3;
      }
         const payload = {
        userId: this.userId,
        statusId: statusId,
      };
      this.$store
        .dispatch("auth/updateStatus", payload)
        .then((res) => {
          this.activeUserFlag = false;
          this.inActiveUserFlag = false;
          this.getList();
          this.$vs.notify({
            title: "Success",
            text: res.message,
            position: "top-right",
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
            color: "success",
          });
        })
        .catch((error) => {
          this.popupApprove = false;
          this.$vs.notify({
            title: "Error",
            text: error,
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
    updateUserKey() {
      this.updateUser = false;
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: "All",
        value: "all",
      };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    getList(callFromSort=false) {
      const postData = {
        sorting: this.sortKey,
        filters: { title:this.serch_title,
        createdOnRange:[],
        },
        page: this.page,
        perpage: this.perPage,
        category: 'user_role'
      };
      this.loading =true;
      if(!callFromSort){
             this.rolesList = [];
      }
   
        this.$store.dispatch("getDominList", postData).then((response) => {
        this.rolesList = response.list;
        this.totalpages = Math.ceil(response.totalCount / this.perPage);
        this.loading =false;
            this.$vs.loading.close();
         
    })
     .catch((err) => {
          console.log(err);
          this.loaded = true;
          this.loading =false;
          this.$vs.loading.close();
        });

     /* this.$store
        .dispatch("auth/get_users_list", postData)
        .then((response) => {
          this.usersList = response.list;
          console.log('usersList!!!!', this.usersList)
          this.totalpages = Math.ceil(response.totalCount / this.perPage);
        })
        .catch((err) => {
          console.log(err);
          this.loaded = true;
        });*/
    },
    apply_filter(data , callFromSort=false) {
      this.filterData = data;
      this.page = 1;
      this.userFilters = {
        title: this.serch_title,
        roleIds: [],
        statusIds: [],
        createdOnRange: [],
      };
      if (this.filterData["roleIds"].length > 0) {
        for (let i = 0; i < this.filterData["roleIds"].length; i++) {
          this.userFilters["roleIds"].push(
            this.filterData["roleIds"][i]["_id"]
          );
        }
      }
      this.settings = {
        sdkDownload: false,
        sdkDocs: false,
        supportTicket: false,
      };

      if (data["statusIds"].length > 0) {
        this.userFilters["statusIds"] = [];
        if (this.filterData["statusIds"].length > 0) {
          for (let i = 0; i < this.filterData["statusIds"].length; i++) {
            this.userFilters["statusIds"].push(
              this.filterData["statusIds"][i]["_id"]
            );
          }
        }
      }
      this.page = 1;
      this.getList(callFromSort);
    },
    clearFilters() {
      this.serch_title = "";
      this.selected_createdDateRange = {}
      this.filtersList =false;
      // this.filterDateRange = [];
      // this.filterData = {
      //   title: this.serch_title,
      //   roleIds: [],
      //   statusIds: [],
      //   createdOnRange: [],
      // };

      // this.userFilters = {
      //   title: this.serch_title,
      //   roleIds: [],
      //   statusIds: [],
      //   createdOnRange: [],
      // };
      this.page = 1;
      this.getList();
    },
    sortMe(sort_key = "") {
      this.sortKey = { path: "createdOn", order: 1 };
      if (sort_key != "") {
        this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        this.sortKey = {};

        this.sortKey["path"] = sort_key;
        this.sortKey["order"] = this.sortKeys[sort_key] == 1 ? -1 : 1;

        this.apply_filter(this.filterData ,true);
      }
    },
    deleteMe() {
      
      const payload = {
        domainId: this.domainCreate['_id']
      };
      this.$store
        .dispatch("deleteDomainConfig", payload)
        .then((res) => {
          this.deletePopup = false;
          this.getList();
          this.$vs.notify({
            title: "Success",
            text: res.message,
            position: "top-right",
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
            color: "success",
          });
        })
        .catch((error) => {
        
          this.$vs.notify({
            title: "Error",
            text: error,
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
    
    openOndelete(item) {
    this.domainCreate = item;
     this.deletePopup = true;
    },
    
    initUser() {
      this.domainCreate = {
        domainName: "",
        companyName:'',
        ndaSigned:false

      };
    },
   
    onEnter() {
      this.getList();
    },
    onSubmit() {
      let payload = this.domainCreate;
     
      if (this.updateUser) {
        

          payload = Object.assign(payload,{ "domainId":this.userId})
         
        
        this.$store
          .dispatch("domainConfigUpdate", payload)
          .then((res) => {
            this.popupcreateticket = false;
            this.updateUserKey();
            this.getList();
            this.initUser();
            this.$vs.notify({
              title: "Success",
              text: res.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              position: "top-right",
              color: "success",
            });
          })
          .catch((error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error",
              text: error.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          });
      } else {
        this.$store
          .dispatch("domainConfigCreate", payload)
          .then((res) => {
            this.popupcreateticket = false;
            this.updateUserKey();
            this.getList();
            this.initUser();
            this.$vs.notify({
              title: "Success",
              text: res.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              position: "top-right",
              color: "success",
            });
          })
          .catch((error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error",
              text: error.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          });
      }
    },
    change_perPage() {
      this.page = 1;

      this.getList();
    },
    getDetails(item) {
      this.popupTitle = "Edit Domain";
      this.userId = "";
      this.initUser();
    
      this.domainCreate.domainName = item.domainName;
      this.domainCreate.companyName = item.companyName;
      this.domainCreate.ndaSigned = item.ndaSigned;

       this.userId = item._id;
      this.updateUser = true;
          this.popupcreateticket = true;
     /* this.userId = id;
      const payload = {
        userId: id,
      };
      console.log("userDetailspaylod", payload);
      this.$store
        .dispatch("getUserDetails", payload)
        .then((res) => {
          console.log("resss Details", res);
          if (res.details) {
            this.domainCreate.name = res.details.name;
            this.domainCreate.email = res.details.email;
            this.domainCreate.phone = res.details.phone;
            //  this.domainCreate.phoneCode = "852"
          }
          if (res.roleDetails) {
            this.domainCreate.roleId = res.roleDetails._id;
          }
          this.updateUser = true;
          this.popupcreateticket = true;
          //  this.user =  Object.assign(this.user, response.result);
          //  this.domainCreate = res;
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.message,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });*/
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.sortKey = { path: "createdOn", order: 1 };
    this.sortKeys = {
       companyName: 1,
        domainName: 1,
        createdOn: -1,
    };

    this.selected_settings = [];
     this.activeUserFlag = false
      this.inActiveUserFlag = false
      this.updateUser = false;

    this.getList();

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
    this.$store.dispatch("getRoles").then((response) => {
      this.userRoles = response;
      this.createUserRoles = this.userRoles.map((item) => item.name);
    });
    //getuser_status
    this.$store.dispatch("getuser_status").then((response) => {
      this.status_list = response;
    });
    //get settings
    this.$store.dispatch("getSettings").then((response) => {
      this.settings_list = response;
    });
  },
  created() {
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule("userManagement", moduleUserManagement);
      moduleUserManagement.isRegistered = true;
    }
    this.$store.dispatch("userManagement/fetchUsers").catch((err) => {
      console.error(err);
    });
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
.ag-header {
  height: 55px !important;
  min-height: 55px !important;
}
.ag-header-container .ag-header-row:nth-last-child(1) {
  display: none;
}
.not-data-table {
  display: none;
}
</style>
